import {useNavigation} from '@react-navigation/native';

import {UseAppNavigationParamList} from '../models/navigationTypes';

const useAppNavigation = useNavigation<UseAppNavigationParamList>;

export default useAppNavigation;
